export default {
  name: "PartnershipAlliance",
  methods: {
    externalLink(url) {
      window.open(url, "_blank");
    }

  }
};